<script>
    import Checkbox from 'svelte-checkbox/Checkbox.svelte';
    import Text from '../../Text.svelte';
    import clsx from 'clsx';
    import StatusIcon from '$lib/components/_DisplayComponents/FormQuestion/InputTypes/StatusIcon.svelte';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    export let invalid = false;
    export let isFirst = false;
    export let isLast = false;
    export let wysiwyg = {};
    export let finalFormInput = {};
    export let errorMessage = '';
    export let touched = false;

    let checkedControlled = false;
    let wrapperClasses;
    let checkboxElementContainer;

    $: {
        // this will detect when the focusable checkbox has been focused or blurred
        // like this we can use final form input's way of detecting if the input is touched
        if (checkboxElementContainer) {
            const checkboxElements = checkboxElementContainer.getElementsByTagName('input');

            if (checkboxElements.length === 1) {
                checkboxElements[0].addEventListener('focus', finalFormInput.onFocus);
                checkboxElements[0].addEventListener('blur', finalFormInput.onBlur);
            }
        }
    }

    const handleTextClick = () => {
        checkedControlled = !checkedControlled;
    };

    const handleClick = ({ detail }) => {
        finalFormInput.onFocus();
        finalFormInput.onChange(detail);
    };

    const borderRadius = getBorderRadius('fieldsWrapper');

    $: wrapperClasses = clsx(
        borderRadius,
        'wrapper checkbox flex px-6 relative box-border overflow-hidden bg-white border-t border-l border-r transition-all',
        {
            ['min-h-[68px]']: !invalid || !touched,
            ['min-h-[90px]']: invalid && touched,
            ['rounded-b-none']: !isLast,
            ['rounded-t-none']: !isFirst,
            ['border-b']: isFirst && isLast,
            ['border-black/10']: !invalid,
        },
    );
</script>

<div class={wrapperClasses} bind:this={checkboxElementContainer}>
    <StatusIcon showError={invalid} showSuccess={false} showCheckmark={false} />

    <Checkbox
        class="mt-6"
        size="24px"
        primaryColor="#0BB648"
        secondaryColor="#D2D2D2"
        checked={!!finalFormInput.value}
        {checkedControlled}
        on:change={handleClick}
    />
    <div class="flex-col">
        <button class="text mt-2.5" on:click={handleTextClick} type="button">
            <Text
                raw={wysiwyg}
                align="left"
                color="#0F0F0F"
                linkColor="#0F0F0F"
                openLinksInNewTab
                stopPropagationOfLinkClicks
            />
        </button>

        {#if errorMessage && invalid}
            <div class="mb-4 ml-4 flex text-xs font-normal leading-tight text-[#ef444a]">
                {errorMessage}
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    .wrapper {
        box-shadow: 0 1px 1px 0 rgba(#000, 0.1);

        & > :global(.checkbox) {
            flex-shrink: 0;
        }
    }
</style>
